import React from 'react';
import Footer from '../Footer/Footer';
import aboutImage from '../../Assets/Images/AboutAug.jpeg';

import './About.css';

const About = () => {
  return (
    <div className="about-page-main">
      <div className="about-content-box">
        <div className="about-top-row">
          <div className="about-text-left">
            <h1>About Cowdog Tech</h1>
            <p>
              Cowdog Technologies is more than just a business — it’s a family venture built on our passion for technology, providing efficient and cost-effective solutions with quality workmanship!
            </p>
            <p>
              While the entire business is inspired by our furry family, the name “Cowdog” comes from our newest member, Augustus. As a piebald dachshund, his unique black-and-white spots make him look like a tiny cow 🐄, and he’s become our official mascot! Whether you’re after a quick fix, a smart upgrade, or a full-on build from the ground up, Cowdog’s the place to keep your circuits running strong.
            </p>
          </div>

          <div className="about-right-column">
            <div className="about-image-right">
              <img src={aboutImage} alt="Augustus the Cowdog" />
            </div>
          </div>
        </div>

        <div className="about-bottom-text">
          <p>
            Founded by Marc, with professional experience in PCB assembly, rework, and modifications, Cowdog Tech transforms big-picture ideas into elegant, real-world solutions. We work closely as a family to bring creativity and care to every project, whether building custom solutions, optimizing workflows, or restoring classic hardware.
          </p>
          <p>
            And yes, Augustus and all his siblings are usually somewhere nearby providing assistance, whether that means ‘supervising’ from one of their many beds (we have lots lol) or offering very important safety tips... mostly by reminding us to take breaks for some pets.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
